import axiosInstance from '../Interceptors/axiosInstance.jsx';
import Cookies from 'js-cookie';

const headers = {
  'accept': '*/*',
  'Authorization': `Bearer ${Cookies.get('accessToken')}`,
  'Content-Type': 'application/json',
}; 

export const addUser = async (ownerData) => {
  const formData = new FormData();
    formData.append('UserName', ownerData.UserName);
    formData.append('UserId', ownerData.UserId);
    formData.append('UserRole', ownerData.UserRole);
    formData.append('EmailId', ownerData.EmailId);
    formData.append('ContactNo', String(ownerData.ContactNo || "").replace(/\s/g, ""));
    formData.append('Password', ownerData.owner_password);

    if (ownerData.profileImage) {
      formData.append('ProfileImage', ownerData.profileImage); 
    }
    const response = await axiosInstance.post('access/add-user', formData, {  headers: {
      'Authorization': `Bearer ${Cookies.get('accessToken')}`,
    }, });
    return response.data;
};

const defaultUserListPayload = {
  pageSize: 10,
  pageNo: 1,
  sParam: "",
  fromDate: "",
  toDate: "",
};

export const getUsers = async (params = {}) => {
  const payload = {
    ...defaultUserListPayload,
    ...params,
  };

  return await axiosInstance.post("access/users", payload, { headers });
};

export const deleteUser = async (userid) => {
  return await axiosInstance.delete(`access/delete-user/${userid}`, { headers });
};

export const blockUnblockUser = async (userId, status) => {
  const response = await axiosInstance.put("access/user/block-unblock", null, {
    params: { userId, status },
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};


export const updateUser = async (payload) => {
  return await axiosInstance.put('access/update-user', payload, {  headers: {
    'Authorization': `Bearer ${Cookies.get('accessToken')}`,
  }, });
};


export const fetchUserById = async (userid) => {
  const response = await axiosInstance.get(`access/user/${userid}`, { headers });
    return response.data.result;
};


export const changePassword = async (data) => {
 return await axiosInstance.put('access/change-password',data, {headers});
}

export const createPassword = async (data) => {
  const response = await axiosInstance.put(
    "access/create-password",
    {
      Id: Number(data.id),
      NewPassword: String(data.newPassword).trim(),
    },
    { headers }
  );
  return response.data;
};

export const fetchUserProfile = async () => {
  return await axiosInstance.get('access/my-profile', {headers});
  };


export const updateProfilePage = async (payload) => {
  const response = await axiosInstance.put('access/my-profile', payload, {  headers: {
    'Authorization': `Bearer ${Cookies.get('accessToken')}`,
  }, });
  return response.data;
  };